import { DataType } from '@/util/index'

const PAYMENT_SCHEDULE = {
  section: {
    name: 'payment-schedule',
    caption: 'PAYMENT SCHEDULE'
  },
  sectionFields: [
    { label: 'Action', template: '{action}', fieldKey: 'action', icon: 'menu' },
    { label: '#', template: '{index}', fieldKey: 'index' },
    { label: 'DATE', template: '{transactionDate}', fieldKey: 'transactionDate' },
    { label: 'MODE', template: '{transactionMode}', fieldKey: 'transactionMode', options: { transactionMode: DataType.TransactionMode } },
    { label: 'TYPE', template: '{transactionType}', fieldKey: 'type', options: { transactionType: DataType.TransactionTypeOptions } },
    { label: 'CHANGE TYPE', template: '{changeType}', fieldKey: 'changeType', options: { changeType: DataType.ChangeType } },
    { label: 'STATUS', template: '{transactionStatus}', fieldKey: 'transactionStatus', options: { transactionStatus: DataType.TransactionStatusEnum } },
    { label: 'AMOUNT', template: '{transactionAmount}', fieldKey: 'transactionAmount', format: 'currency' },
    { label: 'PRINCIPAL', template: '{principal}', fieldKey: 'principal', format: 'currency' },
    { label: 'FINANCE CHARGE', template: '{interest}', fieldKey: 'financeFee', format: 'currency' },
    { label: 'UNPAID FINANCE', template: '{unpaidFee}', fieldKey: 'unpaidFee', format: 'currency' },
    { label: 'LATE FEE', template: '{lateFee}', fieldKey: 'lateFee', format: 'currency' },
    { label: 'NSF FEE', template: '{nsfFee}', fieldKey: 'nsfFee', format: 'currency' },
    { label: 'BANK FEE', template: '{bankFee}', fieldKey: 'bankFee', format: 'currency' },
    { label: 'RETURN CODE', template: '{returnCode}', fieldKey: 'returnCode' },
    { label: 'RETURN DATE', template: '{returnAt}', fieldKey: 'returnAt', format: 'dateWithZero' },
    { label: 'TRANSACTION #', template: '{transactionNo}', fieldKey: 'transactionNo' },
    { label: 'TRANSACTION PROVIDER', template: '{transactionProvider}', fieldKey: 'transactionProvider' }
  ]
}

const PAYMENT_AMOUNT = {
  LEFT: [
    { label: 'PRINCIPAL', template: '{totalUnpaidPrincipal}', fieldKey: 'totalUnpaidPrincipal', format: 'currency' },
    { label: 'FINANCE CHARGE', template: '{totalUnpaidInterest}', fieldKey: 'totalUnpaidInterest', format: 'currency' },
    { label: 'UNPAID FINANCE', template: '{totalUnpaidLateInterest}', fieldKey: 'totalUnpaidLateInterest', format: 'currency' }
  ],
  RIGHT: { label: 'TOTAL', template: '{totalUnpaidAmount}', fieldKey: 'totalUnpaidAmount', format: 'currency' }
}

export { PAYMENT_SCHEDULE, PAYMENT_AMOUNT }
